// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PostApiAccountsLoginData, PostApiAccountsLoginResponse } from './types.gen';

/**
 * Successful login
 * Successful login
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AccountToken Login succesful
 * @throws ApiError
 */
export const postApiAccountsLogin = (data: PostApiAccountsLoginData): CancelablePromise<PostApiAccountsLoginResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/accounts/login',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};